import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "keys"
})
export class KeysPipe implements PipeTransform {
  transform(value: any): Array<{ key: string, value: any }> {
    return Object.entries(value).map(([key, value]) => ({ key, value }));
  }
}